import { Card, CardActionArea, CardContent, Grid, Typography } from "@mui/material";
import { FC } from "react";
import { Link as RouterLink } from "react-router-dom";


const ClassificationProtectionSettings: FC = () => {
  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={6}>
          <Card>
            <CardActionArea {...actionTo("/settings/securefile/classification-rules")}>
              <CardContent>
                <Typography variant="subtitle1">File Classification Rules</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card>
            <CardActionArea {...actionTo("/settings/securefile/data-protection-rules")}>
              <CardContent>
                <Typography variant="subtitle1">File Protection Rules</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card>
            <CardActionArea {...actionTo("/settings/securefile/info-types")}>
              <CardContent>
                <Typography variant="subtitle1">File Info Types</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
        <Grid item xs={6}>
          <Card>
            <CardActionArea {...actionTo("/settings/securefile/document-types")}>
              <CardContent>
                <Typography variant="subtitle1">Document Types</Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      </Grid>
    </>
  )
}

export default ClassificationProtectionSettings;

const actionTo = (to:string) => ({
  LinkComponent: RouterLink,
  to,
  href: to,
})
